import type {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import type {
	AcceptAgenticWorkerResultInput,
	AcceptAgenticWorkerResultMutation,
} from './__generated__/AcceptAgenticWorkerResultMutation.graphql';
import type {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

const mutation = graphql`
	mutation AcceptAgenticWorkerResultMutation($input: AcceptAgenticWorkerResultInput!) {
		acceptAgenticWorkerResult(input: $input) {
			accepted
			refusalReason
			result {
				id
				state
				hidden
				actedAt
				actedBy {
					fullName
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<AcceptAgenticWorkerResultInput>,
	onSuccess?: RelayOnCompleted<AcceptAgenticWorkerResultMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<AcceptAgenticWorkerResultMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
